<div class="container p-4" style="    max-width: 1320px;">
    <div class="card">

        <div *ngIf="paymentResult==null">
            <div class="text-center m-auto" style="max-width: 500px;margin: auto;">

                <img src="assets/loader.gif" style="width: 80px !important;"/>
                <h3>Please wait ... </h3>
                <br>
                <p i18n="knet_thank_you">Please wait while we confirm your payment.</p>
            </div>

        </div>
        <br>
        <div *ngIf="paymentResult=='success'">
            <div class="text-center m-auto" style="max-width: 500px;margin: auto;">

                <i class="la la-check-circle" style="font-size: 80px; color:green;  margin-bottom: 10px;"></i>
                <h3>Payment Confirmed</h3>
                <br>
                <p i18n="knet_thank_you">Thank you for placing your order.
                    You will be now redirected to the Mastercard payment gateway to complete your order
                    payment.</p>

                <div>Reference: {{resultIndicator}}</div>
            </div>

        </div>

        <div *ngIf="paymentResult=='failure'">
            <div class="text-center m-auto" style="max-width: 500px;margin: auto;">

                <i class="la la-times-circle" style="font-size: 80px;color:#8c1a1a;margin-bottom: 10px;"></i>
                <h3>Payment Failed</h3>
                <br>
                <p i18n="knet_thank_you">An error occurred while processing your payment. please check with your card issuer.</p>

                <div>Reference: {{resultIndicator}}</div>
            </div>

        </div>


    </div>


</div>

